import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { VexRoutes } from '../../@vex/interfaces/vex-route.interface';
import { RecuperarContrasenaComponent } from './recuperar-contrasena/recuperar-contrasena.component';

const routes: VexRoutes = [{
    path: '',
    component: LoginComponent
},
{
    path: 'forgot-password',
    component: RecuperarContrasenaComponent,
}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LoginRoutingModule {}
